/**
 * Function for generating a link, including any relevant query string parameters,
 * to the Explore page in this directory
 *
 * Takes an object with some fields, eg:
 * {
 *  "Topic": ["Healthcare"]
 * }
 *
 * and converts it into an explore state obj, depending on how that Explore
 * page "highlights" or "filters" data
 * for example:
 * {
 *  type: "Healthcare"
 * }
 *
 * The <ExploreLink /> component will take this obj and stringify it
 * to generate a URL to the Explore page.
 */

import { ExploreLinkFields } from 'components/navigation/ExploreLink/ExploreLink'

function getExploreState(fields: ExploreLinkFields) {
  // for columns page, we just want to pass it a "type" so it can expand the
  // appropriate column
  return { filters: { Topic: fields['Topic'] } }
}
export default getExploreState
